import { render, staticRenderFns } from "./ClassroomStreamBanner.vue?vue&type=template&id=62858557&scoped=true&"
import script from "./ClassroomStreamBanner.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62858557",
  null
  
)

export default component.exports